import { Pedido } from '@/__env/lib/Ventas/Pedidos/Pedido.nav';
import { Articulo } from '@/__env/lib/Articulos';
import { Item } from '@/__env/lib/Ventas/Pedidos/Item';
import { Pago } from '@/__env/lib/Ventas/Pagos';
import { Cliente, Condiciones, Personas } from '@/__env/lib/Clientes';
import { Envio } from '@/__env/lib/Ventas/Envios';
import { Transporte } from '@/__env/lib/Expedicion/Transportes';

import * as Envios from '@/__env/lib/Ventas/Envios';
import * as Pedidos from '@/__env/lib/Ventas/Pedidos';
import * as Pagos from '@/__env/lib/Ventas/Pagos';
import moment from 'moment';

export async function ImportarPedidoDesdeExcel( row: Record<string, string> , tipo: Pedidos.Tipos )
{
    let Control: number = 0;
    for ( let key of Object.keys( row ) )
    {
        let col = row[key];
        if ( col.length == 0 )
            Control++;
    }
    if ( Control == Object.keys( row ).length )
        return null;

    if ( !tipo)
        return null;

    let pedido = new Pedido();
    pedido.Tipo = tipo;
    pedido.Cliente = new Cliente();
    pedido.Envio = new Envio();
    pedido.Envio.Tipo = Envios.Tipos.Plataforma;

    pedido.Items.push( new Item() );
    pedido.Pagos.push( new Pago() );
    pedido.Items[0].Cantidad = 1;
    pedido.Pagos[0].Fechas.Creacion = moment();
    pedido.Pagos[0].Fechas.Aprobacion = moment();

    for ( let key of Object.keys( row) )
    {
        let col = row[key];
        if ( col.toLowerCase() == 'null' ) col = '';
        else if ( col.toLowerCase() == '\n' ) col = '';
        else if ( col.toLowerCase() == '"' ) col = '';

        if ( key == 'cliente-id' )
        {
            pedido.Cliente.Id = parseInt( col );
        }
        else if ( key == 'cliente-nombre' ) { pedido.Cliente.Nombre = col; }
        else if ( key == 'cliente-apellido' ) { pedido.Cliente.Apellido = col; }
        else if ( key == 'cliente-completo' ) { pedido.Cliente.Nombre = col; }
        else if ( key == 'cliente-documento' )
        {
            pedido.Cliente.Documento = col.borraLetras();
        }
        else if ( key == 'cliente-cuit' )
        {

            pedido.Cliente.Cuit = col.eliminar( '-' );
            pedido.Cliente.CondicionIva = Condiciones.ResponsableInscripto;
        }
        else if ( key == 'cliente-telefono' )
        {
            pedido.Cliente.Contacto.Telefono = col.borraLetras();
        }
        else if ( key == 'cliente-celular' )
        {
            pedido.Cliente.Contacto.Celular = col.borraLetras();
        }
        else if ( key == 'cliente-email' )
        {
            pedido.Cliente.Contacto.Email = col;
        }
        else if ( key == 'cliente-direcion-calle' ) { pedido.Cliente.Direccion.Calle = col; }
        else if ( key == 'cliente-direcion-numero' ) { pedido.Cliente.Direccion.Numero = col; }
        else if ( key == 'cliente-direcion-piso' ) { pedido.Cliente.Direccion.Piso = col; }
        else if ( key == 'cliente-direcion-departamento' ) { pedido.Cliente.Direccion.Departamento = col; }
        else if ( key == 'cliente-direcion-localidad' ) { pedido.Cliente.Direccion.Localidad = col; }
        else if ( key == 'cliente-direcion-provincia' ) { pedido.Cliente.Direccion.Provincia = col; }
        else if ( key == 'cliente-direcion-codigo-postal' ) { pedido.Cliente.Direccion.CodigoPostal = col.borraLetras(); }

        else if ( key == 'envio-importe-propio' )
        {
            pedido.Envio.Importes.Propio = parseFloat( col);
        }
        else if ( key == 'envio-importe-comision' )
        {
            pedido.Envio.Importes.Base = parseFloat( col );
            pedido.Envio.Importes.Bonificado = parseFloat( col );
        }
        else if ( key == 'envio-importe-cliente' )
        {
            pedido.Envio.Importes.Cliente = parseFloat( col );

        }
        else if ( key == 'envio-empresa' )
        {
            let trs = await Transporte.find( { q: col } );
            if ( !trs.Error &&  trs.Items.hasRows() )
            {
                pedido.Envio.EmpresaLogistica = trs.Items[0];
                for ( let e of trs.Items )
                {
                    if ( e.Descripcion.trim().toLowerCase() == col.toLowerCase() )
                        pedido.Envio.EmpresaLogistica = e;
                }
            }
        }
        else if ( key == 'envio-tipo' )
        {
            let e = Envios.Tipos.toTipo( col);
            if ( e.Id != e.Descripcion )
            {
                pedido.Envio.Tipo = e;
            }
        }
        else if ( key == 'envio-tracking' )
        {
            pedido.Envio.Tracking.Codigo = col;
        }
        else if ( key == 'envio-direcion-recibe' ) { pedido.Envio.Direccion.Recibe = col; }
        else if ( key == 'envio-direcion-documento' ) { pedido.Envio.Direccion.Documento = col; }
        else if ( key == 'envio-direcion-telefono' ) { pedido.Envio.Direccion.Telefono = col; }
        else if ( key == 'envio-direcion-calle' ) { pedido.Envio.Direccion.Calle = col; }
        else if ( key == 'envio-direcion-numero' ) { pedido.Envio.Direccion.Numero = col; }
        else if ( key == 'envio-direcion-piso' ) { pedido.Envio.Direccion.Piso = col; }
        else if ( key == 'envio-direcion-departamento' ) { pedido.Envio.Direccion.Departamento = col; }
        else if ( key == 'envio-direcion-calle-completa' ) { pedido.Envio.Direccion.Calle = col; }
        else if ( key == 'envio-direcion-localidad' ) { pedido.Envio.Direccion.Localidad = col; }
        else if ( key == 'envio-direcion-provincia' ) { pedido.Envio.Direccion.Provincia = col; }
        else if ( key == 'envio-direcion-codigo-postal' ) { pedido.Envio.Direccion.CodigoPostal = col; }
        else if ( key == 'envio-direcion-entre' ) { pedido.Envio.Direccion.EntreCalles = col; }
        else if ( key == 'envio-direcion-comentario' ) { pedido.Envio.Direccion.Comentario = col; }

        //else if ( key == 'pedido-fecha' ) { pedido.Fecha.cuit = ; }
        else if ( key == 'pedido-id-externa' ) { pedido.IdExterna = parseInt( col.borraLetras()); }

        else if ( key == 'articulo-id-externa' )
        {
            pedido.Items[0].IdExterna = col;
        }
        else if ( key == 'articulo-id' )
        {
            pedido.Items[0].Codigo = col.formatearCodigoArticulo();
            pedido.Items[0].Articulo = await Articulo.create(col);
        }
        else if ( key == 'articulo-cantidad' ) { pedido.Items[0].Cantidad = parseFloat( col ); }
        else if ( key == 'articulo-importe-iva' ) { pedido.Items[0].PrecioUnitario.Final = parseFloat( col ); }
        else if ( key == 'articulo-importe-sin-iva' ) { pedido.Items[0].PrecioUnitario.Neto = parseFloat( col ); }

        else if ( key == 'pago-importe-pagado' ) { pedido.Pagos[0].Importes.Pagado = parseFloat( col ); }
        else if ( key == 'pago-importe-financiacion' ) { pedido.Pagos[0].CostoFinanciero.Monto = parseFloat( col ); }
        else if ( key == 'pago-importe-comision' ) { pedido.Pagos[0].Comision.Monto = parseFloat( col ); }
        else if ( key == 'pago-referencia' ) { pedido.Pagos[0].ReferenciaExterna = col; }
        else if ( key == 'pago-medio' ) { pedido.Pagos[0].Descripcion = col; }
        else if ( key == 'pago-id-externa' ) { pedido.Pagos[0].IdExterna = parseInt( col ); }
        else if ( key == 'pago-cuotas' ) { pedido.Pagos[0].Financiacion.Cuotas = parseInt( col ); }
        else if ( key == 'pago-importe-cuotas' ) { pedido.Pagos[0].Financiacion.Importe = parseFloat( col ); }

    }

    if ( pedido.Cliente.Direccion.Valida && !pedido.Envio.Direccion.Valida )
    {
        pedido.Envio.Direccion.Calle = pedido.Cliente.Direccion.Calle;
        pedido.Envio.Direccion.Numero = pedido.Cliente.Direccion.Numero;
        pedido.Envio.Direccion.Piso = pedido.Cliente.Direccion.Piso;
        pedido.Envio.Direccion.Departamento = pedido.Cliente.Direccion.Departamento;
        pedido.Envio.Direccion.CodigoPostal = pedido.Cliente.Direccion.CodigoPostal;
        pedido.Envio.Direccion.Localidad = pedido.Cliente.Direccion.Localidad;
        pedido.Envio.Direccion.Provincia = pedido.Cliente.Direccion.Provincia;
        pedido.Envio.Direccion.Pais = pedido.Cliente.Direccion.Pais;
    }
    else if ( !pedido.Cliente.Direccion.Valida && pedido.Envio.Direccion.Valida )
    {
        pedido.Cliente.Direccion.Calle = pedido.Envio.Direccion.Calle;
        pedido.Cliente.Direccion.Numero = pedido.Envio.Direccion.Numero;
        pedido.Cliente.Direccion.Piso = pedido.Envio.Direccion.Piso;
        pedido.Cliente.Direccion.Departamento = pedido.Envio.Direccion.Departamento;
        pedido.Cliente.Direccion.CodigoPostal = pedido.Envio.Direccion.CodigoPostal;
        pedido.Cliente.Direccion.Localidad = pedido.Envio.Direccion.Localidad;
        pedido.Cliente.Direccion.Provincia = pedido.Envio.Direccion.Provincia;
        pedido.Cliente.Direccion.Pais = pedido.Envio.Direccion.Pais;
    }

    pedido.Pagos[0].Cliente.Nombre = pedido.Cliente.Vista.NombreCompleto;
    pedido.Pagos[0].Cliente.Documento = pedido.Cliente.Documento;
    pedido.Pagos[0].Cliente.Email = pedido.Cliente.Contacto.Email;
    pedido.Pagos[0].Cliente.Telefono = pedido.Cliente.Contacto.Telefono;
    pedido.Pagos[0].Plataforma = Pagos.Plataformas.toTipo( pedido.Tipo.Id );
    pedido.Pagos[0].Cuenta  = pedido.Tipo.Id;
    pedido.Pagos[0].Estado = Pagos.Estados.Autorizado;
    pedido.Pagos[0].Modo = 'plataforma';
    pedido.Items[0].Tipo = pedido.Tipo;


    pedido.ComprobarTotales();

    if ( !pedido.Pagos[0].Importes.Pagado )
    {
        pedido.Pagos[0].Importes.Pagado = pedido.Importes.FinalConEnvio;
        pedido.Pagos[0].Importes.Total = pedido.Importes.FinalConEnvio;
    }

    if ( pedido.Pagos[0].Importes.Pagado > 0 )
    {
        pedido.Pagos[0].Comision.Porcentaje = ( pedido.Pagos[0].Comision.Monto / pedido.Pagos[0].Importes.Pagado );
        pedido.Pagos[0].CostoFinanciero.Porcentaje = ( pedido.Pagos[0].CostoFinanciero.Monto / pedido.Pagos[0].Importes.Pagado );
        pedido.Pagos[0].CargoPorEnvio = pedido.Envio.Importes.Cliente;
    }




    return pedido;
}